const { createSlice } = require("@reduxjs/toolkit");

const collectionCategorySlice = createSlice({
  name: "collectionCategory",
  initialState: {
    collectionCategoryName: null,
  },
  reducers: {
    setcollectionCategory(state, action) {
      const collectionCategoryName = action.payload;

      return (state = {
        collectionCategoryName,
      });
    },
  },
});

export const { setcollectionCategory } = collectionCategorySlice.actions;
export default collectionCategorySlice.reducer;